// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__DOMf2","productName":"Table_productName__iDxjx"};